export const getFieldWithEnding = (field?: string, endingChar = '') => {
  if (!field) return '';
  return `${field}${endingChar}`;
};
